/**
 * Dev-only mock users for login and auth store (Attorney + Experts).
 * TODO: Remove when replaced by me query and real user directory.
 * Reviewers: this file can be skipped in PRs; focus on app logic.
 */
import { UserRole, type Attorney, type Expert } from '~/shared/types';

export const MOCK_ATTORNEYS: Attorney[] = [
  {
    id: 'attorney-1',
    name: 'John Smith',
    role: UserRole.ATTORNEY,
    email: 'john.smith@lawfirm.com',
    firm: 'Smith & Associates',
  },
];

/** Dev: Stripe-connected experts for demo. All three have matters; attorney sees multiple active retainers across different experts. */
export const MOCK_EXPERTS: Expert[] = [
  {
    id: 'expert-1',
    name: 'Dr. Emily Carter',
    role: UserRole.EXPERT,
    email: 'emily.carter@cardiology.com',
    phone: '(303) 555-0142',
    credentials: 'MD, Board Certified Cardiologist',
    hourlyRate: 750,
    specialty: 'Cardiology',
    location: 'Denver, CO',
    travelPreference: 'National',
    stripeConnectOnboarded: true,
    cvUrl: 'https://www.w3.org/WAI/WCAG21/Techniques/pdf/pdf.pdf',
  },
  {
    id: 'expert-2',
    name: 'Robert Chen',
    role: UserRole.EXPERT,
    email: 'robert.chen@cpa.com',
    phone: '212-555-0199',
    credentials: 'CPA',
    hourlyRate: 850,
    specialty: 'Financial',
    location: 'New York, NY',
    travelPreference: 'National',
    stripeConnectOnboarded: true,
    cvUrl: 'https://www.w3.org/WAI/WCAG21/Techniques/pdf/pdf.pdf',
  },
  {
    id: 'expert-3',
    name: 'Maria Santos',
    role: UserRole.EXPERT,
    email: 'm.santos@forensicslab.org',
    phone: '415-555-0173',
    credentials: 'PhD, Forensic Toxicology',
    hourlyRate: 600,
    specialty: 'Forensics',
    location: 'San Francisco, CA',
    travelPreference: 'Regional',
    stripeConnectOnboarded: true,
    cvUrl: 'https://www.w3.org/WAI/WCAG21/Techniques/pdf/pdf.pdf',
  },
  /** Demo: Expert without Stripe connected – use to view Earnings, Profile in non-Stripe state. */
  {
    id: 'expert-demo',
    name: 'Demo Expert (No Stripe)',
    role: UserRole.EXPERT,
    email: 'demo.expert@example.com',
    phone: '(555) 000-0000',
    credentials: 'Demo account',
    hourlyRate: 500,
    specialty: 'Demo',
    location: 'Demo City',
    travelPreference: 'National',
    stripeConnectOnboarded: false,
  },
];

export const MOCK_USERS = [...MOCK_ATTORNEYS, ...MOCK_EXPERTS];
